console.log('ANVIL  | 20 |  src/sparky.js')

/* ===== Hero: Sparks Particle Layer ===== */
const sparksCanvas = document.getElementById('bf-sparks');
{
  const ctx = sparksCanvas.getContext('2d');
  let w=0,h=0, dpr = Math.min(window.devicePixelRatio||1, 2);
  const sparks = Array.from({length: 140}, () => ({
    x: Math.random(), y: Math.random(),
    vx: (Math.random()*0.0007 + 0.0002) * (Math.random()<.5?-1:1),
    vy: -(Math.random()*0.002 + 0.001),
    life: Math.random()*1
  }));
  function resize(){ w=sparksCanvas.clientWidth; h=sparksCanvas.clientHeight;
    sparksCanvas.width = w*dpr; sparksCanvas.height = h*dpr; ctx.setTransform(dpr,0,0,dpr,0,0);
  }
  function tick(){
    ctx.clearRect(0,0,w,h);
    for (const s of sparks) {
      // physics
      s.x += s.vx;
      s.y += s.vy;
      s.vy += 0.00002;
      s.life -= 0.006; // faster fade-out

  // respawn
  if (s.life <= 0 || s.y < -0.05 || s.x < -0.1 || s.x > 1.1) {
    s.x = Math.random();
    s.y = 1.05;
    s.vx = (Math.random() * 0.0007 + 0.0002) * (Math.random() < 0.5 ? -1 : 1);
    s.vy = -(Math.random() * 0.002 + 0.001);
    s.life = 1;
    s.phase = Math.random() * Math.PI * 2; // random flicker offset
    continue;
  }

  const px = s.x * w, py = s.y * h;
  const r = 1.5 + 2.5 * (1 - s.life);
  const t = performance.now() * 0.005 + (s.phase || 0);

  // brightness flicker (sin-based, soft)
  const flicker = 0.75 + 0.25 * Math.sin(t * 6.0 + s.life * 10);
  const alpha = Math.max(s.life * flicker, 0);

  const g = ctx.createRadialGradient(px, py, 0, px, py, r * 8);
  g.addColorStop(0.0, `rgba(255,180,40,${0.9 * alpha})`);
  g.addColorStop(0.2, `rgba(255,120,20,${0.6 * alpha})`);
  g.addColorStop(0.6, `rgba(80,20,0,${0.3 * alpha})`);
  g.addColorStop(1.0, `rgba(0,0,0,0)`);

  ctx.fillStyle = g;
  ctx.beginPath();
  ctx.arc(px, py, r, 0, Math.PI * 2);
  ctx.fill();
}
    requestAnimationFrame(tick);
  }
  resize(); window.addEventListener('resize', resize); tick();
}